// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","syncsWrapper":"syncsWrapper-3Ttes","syncs":"syncs-1dbuO","content":"content-1f-zh","callToAction":"callToAction-2UE8z","screen":"screen-1v6WU","stats":"stats-sgpHo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/syncs/_syncs.css
// module id = 1177
// module chunks = 1